import { render } from "./VueGpickr.vue?vue&type=template&id=31278663&scoped=true"
import script from "./VueGpickr.vue?vue&type=script&lang=js"
export * from "./VueGpickr.vue?vue&type=script&lang=js"

import "./VueGpickr.vue?vue&type=style&index=0&id=31278663&lang=scss&scoped=true"

import exportComponent from "/Users/raven/project/vue-gpickr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31278663"]])

export default __exports__